import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { sortUsers } from '../../pages/SellerProfile/APIs/Helpers';

interface NotificationState {
  notificationRecipients: any[];
  notificationTypes: any[];
  loading: boolean;
  error: null;
  langauge: string;
  submitSuccess: boolean;
  submittingSuccess: boolean; 
  submitting: boolean;
  curr_user_id: string;
  modalDataLoaded1: boolean;
  selectedItem: any;
}

const initialState: NotificationState = {
  notificationRecipients: [],
  notificationTypes: [],
  loading: false,
  error: null,
  langauge: 'en',
  submitSuccess: false,
  submitting: false,
  submittingSuccess: false,
  curr_user_id: '',
  modalDataLoaded1: false,
  selectedItem: null
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    fetchNotificationRecipentsStart(state) {
    },
    fetchNotificationRecipentsSuccess(state, action: PayloadAction<any>) {
      const newUserInfo = action.payload;
      newUserInfo.forEach((user) => {
        const removeDuplicates: string[] = []; //remove duplicates
        if(user.count && typeof user.count === 'string'){
        user.count.split(',').forEach((u) => {
          !removeDuplicates.includes(u) && removeDuplicates.push(u);
        });
      }
        user.notifications = removeDuplicates || [];
        user.count = removeDuplicates.toString();
      });
      const sortedUsers = sortUsers(newUserInfo);
      
      state.notificationRecipients = sortedUsers;
    },
    fetchNotificationRecipentsFailure(state, action: PayloadAction<any>) {
      state.error = action.payload;
    },
    fetchNotificationTypesStart(state) {
    },
    fetchNotificationTypesSuccess(state, action) {
      state.notificationTypes = action.payload;
    },
    fetchNotificationTypesFailure(state, action) {
      state.error = action.payload;
    },
    addNotificationRecipientStart(
      state,
      action: PayloadAction<{ updates: any }>
    ) {
      state.loading = true;
      state.submitSuccess = false;
    },
    addNotificationRecipientSuccess(state, action) {
      state.loading = false;
      state.submitSuccess = true;
    },
    addNotificationRecipientFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.submitSuccess = false;
    },
    resetSubmitSuccess(state) {
      state.submitSuccess = false;
    },
    fetchIndNotifsStart(
      state,
      action: PayloadAction<{ curr_user_id: string }>
    ) {
      state.modalDataLoaded1 = false;
    },
    fetchIndNotifsSuccess(state, action: PayloadAction<any>) {
      const finalData = action.payload;
      if (finalData) {
        const updatedUsers = state.notificationRecipients.map((user) => {
          const removeDuplicates: string[] = [];
          if(finalData.notification_type_id && typeof finalData.notification_type_id === 'string'){
          finalData.notification_type_id.split(',').forEach((u) => {
            !removeDuplicates.includes(u) && removeDuplicates.push(u);
          });
        }
          return user.user_id === state.curr_user_id
            ? {
                ...user,
                notifications: removeDuplicates || [],
                notificationsMandatory: finalData.mandatory,
                count: removeDuplicates.toString(),
                preferred_language_type: finalData.language
              }
            : user;
        });
        state.notificationRecipients = updatedUsers;
        state.modalDataLoaded1 = true;
      }
    },
    fetchIndNotifsFailure(state, action: PayloadAction<any>) {
      state.error = action.payload;
      state.modalDataLoaded1 = false;
    },
    setModalDataLoaded1(state, action: PayloadAction<boolean>) {
      state.modalDataLoaded1 = action.payload;
    },
    setSelectedItem(state, action: PayloadAction<any>) {
      state.selectedItem = action.payload;
    },

    setCurr_user_id(state, action: PayloadAction<string>) {
      state.curr_user_id = action.payload;
    },
    editNotificationStart(
      state,
      action: PayloadAction<{
        curr_user_id: string;
        updates: string[];
        notif_lang_pref: string;
        
      }>
    ) {
      state.submitting = true;
    },
    editNotificationSuccess(state, action) {
      state.submitting = false;
    },
    editNotificationFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.submitting = false;
    },
    setSubmittingSuccess(state, action: PayloadAction<boolean>) {
      state.submittingSuccess = action.payload;
    },
  }
});

export const {
  fetchNotificationRecipentsStart,
  fetchNotificationRecipentsSuccess,
  fetchNotificationRecipentsFailure,
  fetchNotificationTypesStart,
  fetchNotificationTypesSuccess,
  fetchNotificationTypesFailure,
  addNotificationRecipientFailure,
  addNotificationRecipientStart,
  addNotificationRecipientSuccess,
  resetSubmitSuccess,
  setSubmittingSuccess,
  fetchIndNotifsStart,
  fetchIndNotifsSuccess,
  fetchIndNotifsFailure,
  setModalDataLoaded1,
  setSelectedItem,
  setCurr_user_id,
  editNotificationFailure,
  editNotificationStart,
  editNotificationSuccess
} = notificationSlice.actions;
export default notificationSlice.reducer;
